import { useNavigate } from 'react-router-dom'
import { SOMYA_ADDICTION_EVENT_URL } from '../../BehavioralAddictionPlan'
import {
  ReadyToTakeFirstStepButton,
  ReadyToTakeFirstStepCardButtonContainer,
  ReadyToTakeFirstStepCardContainer,
  ReadyToTakeFirstStepCardVideo,
} from './styledComponents'

export default function ReadyToTakeFirstStepCard({ buttonsOnClick }) {
  const navigate = useNavigate()

  return (
    <ReadyToTakeFirstStepCardContainer>
      <ReadyToTakeFirstStepCardVideo
        playing={true}
        url="https://media.aumhum.com/hls/prod/MEDIA-e8ea41decd8a4e5a90e3ceafc384296a/1716205200608/1716205188707_99_7fea089d4c_1_.m3u8"
        controls={false}
        loop
        muted={true}
        playsinline
      />
      <div className="content">
        <h1 className="heading">Ready to Take the First Step?</h1>
        <ReadyToTakeFirstStepCardButtonContainer>
          <ReadyToTakeFirstStepButton
            onClick={() =>
              buttonsOnClick ? buttonsOnClick() : navigate(SOMYA_ADDICTION_EVENT_URL)
            }
            className="button-text"
            sx={{ width: '290px', padding: '16px 40px' }}
          >
            GET STARTED TODAY
          </ReadyToTakeFirstStepButton>
          <ReadyToTakeFirstStepButton
            onClick={() =>
              buttonsOnClick ? buttonsOnClick() : navigate(SOMYA_ADDICTION_EVENT_URL)
            }
            className="button-text"
            sx={{ width: '290px', padding: '16px 40px' }}
          >
            CONTACT US
          </ReadyToTakeFirstStepButton>
        </ReadyToTakeFirstStepCardButtonContainer>
      </div>
    </ReadyToTakeFirstStepCardContainer>
  )
}
